import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import { useAuth } from "@src/common/hooks/useAuth";
import {
  DRIVER_COMPLIANCE_CHECK,
  DriverComplianceCheckData,
  DriverComplianceCheckVars,
  OrderDriverComplianceStatus,
} from "../graphql/queries";

export function useDriverComplianceCheck() {
  const { courierId } = useAuth();

  const [fetchCheck, { loading }] = useLazyQuery<
    DriverComplianceCheckData,
    DriverComplianceCheckVars
  >(DRIVER_COMPLIANCE_CHECK, { fetchPolicy: "network-only" });

  const checkCompliance = useCallback(
    (
      driverId: string,
      orderIds: string[],
    ): Promise<OrderDriverComplianceStatus[]> => {
      if (!courierId || orderIds.length === 0)
        return Promise.resolve([]);
      return fetchCheck({
        variables: { courierId, driverId, orderIds },
      }).then((result) => result.data?.driverComplianceCheck ?? []);
    },
    [courierId, fetchCheck],
  );

  return { checkCompliance, loading };
}
